import { defineStore } from 'pinia';
import sendersAPI from '@/api/senders';
import { useAlertStore } from '@/store/alertStore';

export const useSendersStore = defineStore('senders', () => {
  const alertStore = useAlertStore();

  const sendEmailWithMediaKit = async (contacts: any[]) => {
    try {
      // Puedes mapear los contactos para solo enviar los emails, si tu API lo requiere
      const emails = contacts.map(c => c.email).filter(Boolean);
      if (emails.length === 0) throw new Error('No hay emails seleccionados.');
      await sendersAPI.sendEmailWithMediaKit({ emails });
      alertStore.showAlert('Media Kit enviado correctamente por Email.', 'success');
      return true;
    } catch (error: any) {
      alertStore.showAlert(
        error?.response?.data?.message || 'Ocurrió un error al enviar el Media Kit por Email.',
        'error'
      );
      return false;
    }
  };

  const sendWhatsAppWithMediaKit = async (contacts: any[]) => {
    try {
      // Igual, mapea los whatsapps si tu API lo requiere
      const whatsapps = contacts.map(c => c.whatsapp).filter(Boolean);
      if (whatsapps.length === 0) throw new Error('No hay números seleccionados.');
      await sendersAPI.sendWhatsAppWithMediaKit({ whatsapps });
      alertStore.showAlert('Media Kit enviado correctamente por WhatsApp.', 'success');
      return true;
    } catch (error: any) {
      alertStore.showAlert(
        error?.response?.data?.message || 'Ocurrió un error al enviar el Media Kit por WhatsApp.',
        'error'
      );
      return false;
    }
  };

  return {
    sendEmailWithMediaKit,
    sendWhatsAppWithMediaKit,
  };
});
